
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#0FB400"}}),_c('path',{attrs:{"d":"M26.811 13.6l-.3-.3c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1l-1.802 1.8v-4.4c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7v4.4l-1.803-1.8c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1l-.3.3c-.1.1-.1.2-.1.3 0 .1 0 .2.1.3l3.102 3.1c.1.1.2.1.3.1.1 0 .2 0 .3-.1l3.102-3.1c.1-.1.1-.2.1-.3 0-.1-.1-.3-.1-.3h.001zm-5.704 5.8h-1v-2.3c0-2-1.601-3.5-3.603-3.5-2.001 0-3.602 1.6-3.602 3.5v2.2h-.9c-.602 0-1.002.5-1.002 1v7.1c0 .6.5 1 1 1h9.106c.6 0 1.001-.5 1.001-1v-7.1c0-.5-.4-.9-1-.9zm-4.002 5.4v1.1c0 .3-.2.5-.5.5s-.501-.2-.501-.5v-1.1c-.6-.2-1-.8-1-1.4 0-.8.7-1.5 1.5-1.5s1.501.7 1.501 1.5c0 .7-.5 1.2-1 1.4zm1-5.5l-3.102.1v-2.3c0-.8.7-1.5 1.501-1.5.8 0 1.501.7 1.501 1.5l.1 2.2z","fill":"#fff"}})])
          )
        }
      }
    